import { EmailIntegrationType } from 'crono-fe-common/types/emailSettings';

import { ReactComponent as GmailLogo } from 'assets/images/gmail_logo.svg';
import { ReactComponent as OutlookLogo } from 'assets/images/outlook.svg';
import { ReactComponent as CustomEmailProviderLogo } from 'assets/images/custom_email_provider_logo.svg';
import { SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
  integration: EmailIntegrationType;
}

export const EmailIconFromIntegration = ({ integration, ...props }: IProps) => {
  return integration === EmailIntegrationType.GMAIL ? (
    <GmailLogo
      style={{
        width: 24,
        height: 24,
      }}
      {...props}
    />
  ) : integration === EmailIntegrationType.OUTLOOK ? (
    <OutlookLogo
      style={{
        width: 24,
        height: 24,
      }}
      {...props}
    />
  ) : integration === EmailIntegrationType.CUSTOM ? (
    <CustomEmailProviderLogo
      style={{
        width: 24,
        height: 24,
      }}
      {...props}
    />
  ) : null;
};
